export const stripHtmlTags = (html) => {
  if (!html) return "";
  return String(html)
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
};

/**
 * Client-side checks mirroring JobController::create rules for published jobs.
 * Returns the first validation error message, or null if valid.
 */
export const getJobPublishValidationError = (jobState) => {
  if (!jobState) {
    return "Job details are missing.";
  }

  if (!jobState.campany_name?.trim()) {
    return "The campany name field is required.";
  }

  if (!jobState.role_title?.trim()) {
    return "The role title field is required.";
  }

  if (!jobState.industry || jobState.industry === "0") {
    return "The industry field is required.";
  }

  if (!stripHtmlTags(jobState.about_company)) {
    return "The about company field is required.";
  }

  if (!jobState.job_type || jobState.job_type === "0") {
    return "The job type field is required.";
  }

  if (!jobState.location?.trim()) {
    return "The location field is required.";
  }

  if (!jobState.country || Number(jobState.country) === 0) {
    return "The country field is required.";
  }

  const jobTier = parseInt(jobState.job_tier, 10);
  if (![1, 2, 3].includes(jobTier)) {
    return "The job tier field is required.";
  }

  if (!Array.isArray(jobState.skills_required) || jobState.skills_required.length < 1) {
    return "The skills required field is required.";
  }

  if (jobTier === 3) {
    if (!jobState.salary_range?.trim()) {
      return "Please provide salary range for Tier 3 jobs.";
    }
    if (!jobState.currency || jobState.currency === "0") {
      return "Please provide currency for Tier 3 jobs.";
    }
    if (!jobState.duration || jobState.duration === "0") {
      return "Please provide duration for Tier 3 jobs.";
    }
  }

  if (jobTier === 2) {
    const estimatedViews = parseInt(jobState.estimated_views, 10);
    if (Number.isNaN(estimatedViews) || estimatedViews < 1) {
      return "Please enter a valid Estimated Views (at least 1).";
    }
  }

  return null;
};

export const validateJobForPublish = (jobState) => {
  const message = getJobPublishValidationError(jobState);
  return {
    valid: !message,
    message,
  };
};
